import React, { useState, useEffect } from 'react';
import { Form, InputGroup, FormControl, ListGroup } from 'react-bootstrap';
import './VendorSelector.css';

const VendorSelector = ({ vendorList = [], onSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredVendors, setFilteredVendors] = useState(vendorList);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    setFilteredVendors(vendorList);
  }, [vendorList]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    const filtered = vendorList.filter((v) =>
      v.title.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredVendors(filtered);
    setShowDropdown(true);
  };

  const handleSelect = (vendor) => {
  setSearchTerm(vendor.title);
  setShowDropdown(false);
  onSelect(vendor); // pass full vendor
};

  return (
    <Form.Group controlId="vendorSearch">
      <Form.Label>Select Vendor</Form.Label>
      <InputGroup>
        <FormControl
          type="text"
          placeholder="Search vendors..."
          value={searchTerm}
          onChange={handleSearch}
          onFocus={() => setShowDropdown(true)}
          autoComplete="off"
        />
      </InputGroup>
      {showDropdown && searchTerm.length > 0 && (
        <ListGroup className="vendor-suggestions">
          {filteredVendors.length > 0 ? (
            filteredVendors.map((vendor) => (
              <ListGroup.Item
                key={vendor.id}
                action
                onClick={() => handleSelect(vendor)}
              >
                {vendor.title}
              </ListGroup.Item>
            ))
          ) : (
            <ListGroup.Item disabled>No matching vendors</ListGroup.Item>
          )}
        </ListGroup>
      )}
    </Form.Group>
  );
};

export default VendorSelector;
